// Modules
import React from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';

const withRouter = (Component) => {
    const Wrapper = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        const [URLSearchParams] = useSearchParams();
        const searchParam = URLSearchParams.get('search');
        const application_id = URLSearchParams.get('application_id');
        return (
            <Component
                {...props}
                // router={{ location, navigate, params }}
                location={location}
                navigate={navigate}
                params={params}
                searchParam={searchParam}
                applicationId={application_id}
            />
        );
    };

    return Wrapper;
};

export default withRouter;
